import React, { useState } from "react";
import { Link } from "react-router-dom";

import { SiteRoutes } from "../../config.jsx";

import LocalStorage from "../../components/LocalStorage/index.jsx";
import LD_Logo from "../../assets/images/ld-blanco.png";
import { useContext } from "react";
import {
    UsuarioContext,
    SucursalesContext,
    SucursalContext,
} from "../../Context.jsx";

const Header = () => {
    let baseUrl = document.getElementById("rutaRaizRedireccion").getAttribute("value");

    const { Usuario, setUsuario } = useContext(UsuarioContext);
    const { Sucursales, setSucursales } = useContext(SucursalesContext);
    const { Sucursal, setSucursal } = useContext(SucursalContext);

    const listSucursales = Sucursales !== null ? Sucursales : [];

    const cerrarSesion = () => {
        if (LocalStorage.get("token") !== null) {
            LocalStorage.clear();
            window.location.href =
                baseUrl + "Error?Mensaje=Se ha cerrado la Conexión";
        }
    };

    return (
        <header>
            <div className="brand">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <img
                                src={
                                    Sucursal !== null && Sucursal.Logo !== ""
                                        ? Sucursal.Logo
                                        : LD_Logo
                                }
                            />
                        </div>
                        <div className="col-md-6 text-right">
                            <img src={LD_Logo} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                {(window.location.href.indexOf('/Error') === -1) && (
                    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                        <a className="navbar-brand">
                            Dashboard <span>Ecommerce</span>
                        </a>
                        <button
                            class="navbar-toggler"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div
                            className="collapse navbar-collapse"
                            id="navbarSupportedContent"
                        >
                            <ul className="navbar-nav mr-auto bl-1">
                                <li className="nav-item ">
                                    <Link
                                        className="nav-link"
                                        aria-current="page"
                                        to={SiteRoutes.Cliente}
                                    >
                                        <i className="fas fa-user-tie"></i> Cliente
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className="nav-link"
                                        aria-current="page"
                                        to={SiteRoutes.Ordenes}
                                    >
                                        <i className="fas fa-shopping-basket"></i> Órdenes
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link
                                        className="nav-link"
                                        aria-current="page"
                                        to={SiteRoutes.Articulos}
                                    >
                                        <i className="fas fa-box-open"></i> Artículos
                                    </Link>
                                </li>
                            </ul>
                            <ul className="navbar-nav bl-1">
                                <li className="nav-item dropdown">
                                    <a
                                        className="nav-link dropdown-toggle"
                                        href="#"
                                        id="navbarDropdown"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        {Sucursal !== null ? Sucursal.Nombre : ""}
                                    </a>
                                    <div
                                        className="dropdown-menu"
                                        aria-labelledby="navbarDropdown"
                                    >
                                        {listSucursales.map((x, i) => (
                                            <a
                                                key={i}
                                                className="dropdown-item"
                                                onClick={() => {
                                                    setSucursal(x);
                                                    LocalStorage.set("suc_id", x.Id);
                                                }}
                                            >
                                                {x.Nombre}
                                            </a>
                                        ))}
                                    </div>
                                </li>
                                <li className="nav-item dropdown user-profile">
                                    <a
                                        className="nav-link dropdown-toggle"
                                        id="navbarDropdown"
                                        role="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        href="#"
                                    >
                                        <img
                                            className="user-profile-pic"
                                            src={
                                                Usuario !== null && Usuario.Imagen !== ""
                                                    ? Usuario.Imagen
                                                    : `${baseUrl}Public/img/user-icon.png`
                                            }
                                        />
                                        &nbsp;&nbsp;
                                        {Usuario !== null ? Usuario.Usuario_Nombre : ""}
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <a
                                            className="dropdown-item user-options"
                                            style={{ cursor: "pointer" }}
                                            onClick={cerrarSesion}
                                        >
                                            {" "}
                                            <i className="fas fa-sign-out-alt"></i> Salir
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                )}
            </div>
        </header>
    );
};

export default Header;
